import { isLogtoEnabled } from '@savgroup-front-common/core/services/isLogtoEnabled';

const { hostname } = window.location;
const logtoClientId = '1qy422j8ogbeeipyd3w17';

const defaultAuthority = isLogtoEnabled()
  ? 'https://idp.revers.io/oidc'
  : 'https://login.revers.io';

const mapClientIdByHostname: Record<string, string> = isLogtoEnabled()
  ? {
      'app-cooperative-u.revers.io': 'vbv2u26cyk4pspusa4u9k',
      'app-maisonsdumonde.revers.io': '0zxwzbrqovebymekpe4jm',
      'app-carrefour.revers.io': 'sls60b70exyg69yze5gwz',
      'app-auchan.revers.io': 'e43sgc4ro8xy57ad08gzi',
    }
  : {
      'app.revers.io': 'app.revers.io',
      'app2.revers.io': 'app.revers.io',
      localhost: 'app.revers.io',
    };

const mapAuthorityByHostname: Record<string, string> = isLogtoEnabled()
  ? {
      localhost: defaultAuthority,
    }
  : {
      'control.revers.io': defaultAuthority,
      'app-carrefour.revers.io': 'https://login-revers-io.carrefour.fr',
      'app-auchan.revers.io': defaultAuthority,
      'app-maisonsdumonde.revers.io': defaultAuthority,
      localhost: defaultAuthority,
    };

const mapDirectSigningByHostname: Record<string, string> = {
  'app.revers.io': 'sso:123456789',
  localhost: 'sso:123456789',
  'app2.revers.io': 'sso:123456789',
  'app-cooperative-u.revers.io': 'sso:rr895mcrige4',
  'app-maisonsdumonde.revers.io': 'sso:18ie12chpnb8',
  'app-carrefour.revers.io': 'sso:7r0l0ch3qmhx',
  'app-auchan.revers.io': 'sso:5seusm6k1key',
};

const AuthConfiguration = {
  authority: mapAuthorityByHostname[hostname] || defaultAuthority,
  clientId: isLogtoEnabled()
    ? mapClientIdByHostname[hostname] || logtoClientId
    : mapClientIdByHostname[hostname] || window.location.hostname,
  scope: isLogtoEnabled()
    ? 'openid email api offline_access profile'
    : 'openid email api',
  direct_sign_in: isLogtoEnabled()
    ? mapDirectSigningByHostname[hostname] || 'sso:rcldfwem8cwf'
    : undefined,
};

export default AuthConfiguration;
